import { useRef } from "react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import { Button, Result } from "antd";
import ReportErrorButton from "Components/ReportErrorButton/ReportErrorButton";

function ErrorFallback({ error, resetErrorBoundary, componentStack }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Result
        status="error"
        title="Something went wrong"
        subTitle={
          error?.message ??
          "An unexpected error occurred. You can try refreshing or going back to the dashboard."
        }
        extra={[
          <Button type="primary" onClick={resetErrorBoundary} key="retry">
            Try Again
          </Button>,
          <Button href="/shoup-community/dashboard" key="home">
            Go to Dashboard
          </Button>,
          <ReportErrorButton
            key="report"
            error={error}
            componentStack={componentStack}
            context="ErrorBoundary — React render crash"
          />,
        ]}
      />
    </div>
  );
}

function ErrorBoundary({ children }) {
  const componentStackRef = useRef(null);

  return (
    <ReactErrorBoundary
      FallbackComponent={(props) => (
        <ErrorFallback {...props} componentStack={componentStackRef.current} />
      )}
      onError={(_error, info) => {
        componentStackRef.current = info.componentStack;
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export { ErrorBoundary };
